module.exports = __webpack_public_path__ + "4300b0950d6ee00c508e19bee9223f36.MP3";